import React from "react";
import { BookOpen, Flame } from "lucide-react";

// Simple book + lamp logo. NOT the Ashoka emblem or any government seal.
export default function Logo({ size = 44, className = "" }) {
  return (
    <div
      className={`flex items-center justify-center rounded-md ${className}`}
      style={{ width: size, height: size, background: "#1F3A68" }}
      data-testid="site-logo"
      aria-hidden="true"
    >
      <div className="relative">
        <BookOpen size={size * 0.5} color="#FFFFFF" strokeWidth={2} />
        <Flame
          size={size * 0.26}
          color="#FF9933"
          className="absolute -top-2 left-1/2 -translate-x-1/2"
          fill="#FF9933"
        />
      </div>
    </div>
  );
}
